Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeVideoContentFactory

  create: (jsonSocialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.YoutubeVideoContentParser().parse(jsonSocialContent)
    return content
